<template>
  <div class="account">
    <div class="filter">
      <el-form :inline="true">
        <el-form-item label="账号名称：">
          <el-input
            v-model="model.username"
            placeholder="请输入账号名称"
            @change="getData"
            clearable
          />
        </el-form-item>
        <el-form-item label="数据范围：">
          <el-select
            v-model="model.parkIds"
            placeholder="请选择数据范围"
            @change="getData"
            clearable
          >
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="body">
      <div class="handle">
        <el-button
          type="success"
          icon="el-icon-circle-plus-outline"
          @click="handleAdd"
        >
          添 加
        </el-button>
        <el-button type="info" icon="el-icon-refresh-left" @click="handleReset">
          重置
        </el-button>
        <el-button type="danger" icon="el-icon-delete" @click="batchDelete">
          删 除
        </el-button>
      </div>
      <div class="table-container">
        <el-table
          v-loading="tableLoading"
          :data="tableList"
          @selection-change="selectionChange"
          :height="windowHeight"
        >
          <el-table-column type="selection" width="55" />
          <el-table-column label="账号" prop="username" />
          <!-- <el-table-column
            label="密码"
            prop="password"
          /> -->
          <el-table-column label="类型" prop="dataType">
            <template slot-scope="{ row }">
              <span>{{
                row.dataType == 1
                  ? "门卫"
                  : row.dataType == 2
                  ? "宿管门卫"
                  : row.dataType == 3
                  ? "仓管门卫"
                  : row.dataType == 4
                  ? "管理员"
                  : ""
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="数据范围" prop="parkStr" />
          <el-table-column label="操作" width="55">
            <template slot-scope="{ row }">
              <i class="el-icon-edit handle-edit" @click="handleEdit(row)"></i>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pager">
        <el-pagination
          :current-page="pageData.page"
          :page-sizes="[20, 40, 60, 80, 100]"
          :page-size="pageData.pageSize"
          :total="total"
          @size-change="sizeChange"
          @current-change="currChange"
          layout="total, sizes, prev, pager, next, jumper"
        />
      </div>
    </div>
    <el-dialog
      :title="`${handleType === 'add' ? '新增' : '编辑'}账号`"
      :visible.sync="visible"
    >
      <el-form :model="form" :rules="rules" ref="hook-form">
        <el-form-item label="账号" label-width="80px" prop="username">
          <el-input v-model="form.username" />
        </el-form-item>
        <el-form-item label="密码" label-width="80px" prop="password">
          <el-input v-model="form.password" />
        </el-form-item>
        <el-form-item
          label="类型："
          label-width="80px"
          prop="dataType"
          class="form_item1"
        >
          <el-select
            v-model="form.dataType"
            placeholder="请选择类型"
            style="width: 100%"
          >
            <el-option
              v-for="item in optionsRoleList"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="数据范围" label-width="80px" prop="parkList">
          <el-select
            v-model="form.parkList"
            placeholder="请选择数据范围"
            multiple
          >
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取 消</el-button>
        <el-button :loading="btnLoading" type="primary" @click="handleSubmit">
          确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import apis from "@/apis";

export default {
  name: "account",
  data() {
    return {
      tableLoading: false,
      btnLoading: false,
      model: {
        username: "",
        parkIds: "",
        
      },
      pageData: {
        page: 1,
        pageSize: 20
      },
      options: [],
      tableList: [],
      selection: [],
      optionsRoleList: [
        {
          key: 1,
          value:'门卫'
        },
        {
          key: 2,
          value:'宿管门卫'
        },
        {
          key: 3,
          value:'仓库门卫'
        },
        {
          key: 4,
          value:'管理员'
        },
      ],
      total: 0,
      visible: false,
      handleType: "add",
      form: {
        username: "",
        password: "",
        parkList: [],
        dataType:''
      },
      rules: {
        username: [{ required: true, message: "请输入账号" }],
        dataType: [{ required: true, message: "请选择类型" }],
        password: [{ required: true, message: "请输入密码" }],
        parkIds: [
          {
            required: true,
            validator: (r, v, c) => {
              if (!v.length) return c("请选择园区");
              c();
            }
          }
        ]
      },
      windowHeight: 350
    };
  },
  watch: {
    model: function () {
      this.pageData.page = 1;
    }
  },
  methods: {
    handleResize() {
      // 使用 window.innerHeight 获取窗口的高度
      this.$nextTick(() => {
        this.windowHeight = window.innerHeight - 280;
      });
    },
    //表格选中事件
    selectionChange(v) {
      this.selection = v;
    },
    //重置表单
    resetForm() {
      this.form = {
        username: "",
        password: "",
        parkList: []
      };
    },
    //批量删除
    batchDelete() {
      const ids = this.selection.map(item => item.id);
      if (!ids.length) {
        return this.$message.warning("请选择需要删除的账号");
      }

      this.$confirm("是否确认删除?")
        .then(() => {
          apis.parkUserDelete({ ids }).then(() => {
            this.$message.success("删除成功!");
            this.getData();
          });
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    //新增账号
    handleAdd() {
      this.resetForm();
      this.visible = true;
      this.handleType = "add";
      this.$refs["hook-form"].resetFields();
    },
    //重置搜索条件
    handleReset() {
      this.model = {
        username: "",
        parkIds: ""
      };
      this.getData();
    },
    //编辑账号
    handleEdit(row) {
      const { username, password, parkList, id ,dataType} = row;
      this.form = {
        username,
        password,
        parkList,
        dataType,
        id
      };
      this.visible = true;
      this.handleType = "edit";
    },
    //提交
    handleSubmit() {
      this.$refs["hook-form"].validate().then(valid => {
        if (valid) {
          this.btnLoading = true;
          apis
            .parkUserAddOrUpdate({...this.form,type:1})
            .then(() => {
              this.visible = false;
              this.getData();
            })
            .finally(() => (this.btnLoading = false));
        }
      });
    },
    //分页
    sizeChange(value) {
      this.pageData.pageSize = value;
      this.getData();
    },
    //页码变化
    currChange(value) {
      this.pageData.page = value;
      this.getData();
    },
    //获取园区列表
    getOptions() {
      apis.parkQueryAll({ type: 3 }).then(({ data }) => {
        this.options = data;
      });
    },
    //获取账号列表
    getData() {
      this.tableLoading = true;
      apis
        .parkUserList({
          ...this.pageData,
          ...this.model,
          type:1
        })
        .then(({ data, total }) => {
          this.tableList = data;
          this.total = total;
        })
        .finally(() => (this.tableLoading = false));
    },
    //角色列表
    // queryByRole() {
    //   apis
    //     .queryByTypeList({
    //       type: "role"
    //     })
    //     .then(res => {
    //       if (res.code == 200) {
    //         this.optionsRoleList = res.data;
    //       }
    //     });
    // }
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    this.getData();
    this.getOptions();
    // this.queryByRole()
  }
};
</script>

<style lang="scss" scoped>
.account {
  height: calc(100vh - 77px);
  overflow-y: scroll;
  &::-webkit-scrollbar {
    width: 0px;
    height: 1px;
    background-color: rgba(240, 240, 240, 1);
  }
}
.handle {
  margin-bottom: 15px;
}
.table-container {
  margin-bottom: 20px;
}
.handle-edit {
  cursor: pointer;
}
.pager {
  display: flex;
  justify-content: flex-end;
}
</style>
